import React from 'react';
import './globalStyles.css';
import Hero from './sections/hero';
import About from './sections/about';
import Portfolio from './sections/portfolio';
import Layout from './components/layout';

import { Parallax, ParallaxLayer } from '@react-spring/parallax';
import mountainImage from '../src/assets/mountainImage.jpg';
// src\assets\mountainImage.jpg


class App extends React.Component {

  render() {
    return (
      <div>
        <layout>
          <Parallax pages={3}>
            <ParallaxLayer offset={0}>
              <Hero id="hero" />
            </ParallaxLayer>

            <ParallaxLayer offset={1}
            >
              <About id="about" />
            </ParallaxLayer>

            <ParallaxLayer offset={2}>
              <Portfolio id="portfolio" />
            </ParallaxLayer>

          </Parallax>
        </layout>
      </div>
    )
  }
}

export default App;
